<!-- 

-->

<template>
    <div class="">
        <div class="pipeline col-md-12 col-12" :class="cols">
            <div class="pipeline etapa" v-for="(mes, index) in painel" :key="index">
                <div class="header" style="">
                    <span class="title-etapa w-100 mb-2"> {{ mes.startdate | formatMesExtenso }} </span>
                    <div class="w-100">
                        <span v-if="mes.totais.length > 0 && mes.totais[0].count_negocios > 1" class="card-text text-right">{{ mes.totais[0].count_negocios }} Negócios</span>
                        <span v-if="mes.totais.length > 0" class="card-value">{{ mes.totais[0].moeda }} {{ mes.totais[0].valor | formatValue(2) }} </span>
                    </div>
                </div>
                <draggable class="list-group" v-model="mes.negocios" v-bind="dragOptions" @change="onChange" :move="onMove" @start="isDragging=true" @end="onEnd">
                    <transition-group type="transition" :name="'flip-list'" :mes="index">
                        <!-- CARDS -->
                        <crm-card v-for="negocio in mes.negocios" :key="negocio.codnegocio"  :negocio="negocio"
                            @editNegocio="handleEditNegocio(negocio.codnegocio)" @adicionarAgenda="handleAdicionarAgenda" @editAgenda="handleAdicionarAgenda"></crm-card>
                    </transition-group>
                </draggable>
            </div>
        </div>
        <agenda-form v-if="showFormAgenda" :index="codagenda" :crud="crud" :params="paramsAgenda" @closeform="closeAgenda"></agenda-form>
        <crm-painel-timeline-teste v-if="noDateList.length > 0"></crm-painel-timeline-teste>
    </div>
</template>

<script>
import { SysVars } from '../main';
import { formatValue } from '../shared/utils'
import { apiDateORDS } from '../shared/api-functions'
import draggable from "vuedraggable";
import apiCrm from '../api/api-crm.js'
import CrmCard from './crm-card'
import CrmPainelTimelineTeste from './crm-painel-timeline-teste'

export default {
    props: {
        funil: Object,
        usuario: Object,
        equipe: Object,
        startDate: '',
        filtro: '',  //código do filtro selecionado
    },

    components: {
        draggable, CrmCard, CrmPainelTimelineTeste
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    data () {
        return {
            etapasFunil: [],
            painel: [],  //objeto utilizado para apresentacao

            negocioDragging: null,
            mesTarget: null, //variavel grava o index do mes de destino ao movimentar um card
            isDragging: false,
            delayedDragging: false,

            showFormAgenda: false,
            codagenda: null,
            
            negociocrm: null,
        }
    },

    computed: {
        cols: function () {
            return 'pipeline-5col'
        },

        totalList: function () {
            return this.$store.getters.getNegocioTotais
        },

        negocioList: function () {
            return this.$store.getters.getNegocioList
        },

        etapaList: function () {
            if (this.$store.getters.getConfigCrm.etapas)
              return this.$store.getters.getConfigCrm.etapas
            else
              return []
        },

        funilList: function () {
            if (this.$store.getters.getConfigCrm)
                return this.$store.getters.getConfigCrm.funil
            else
                return []
        },

        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },

        organizacao: function () {
            if (this.negociocrm && this.negociocrm.organizacao.length > 0)
              return this.negociocrm.organizacao[0]
            else 
              return null
        },

        pessoa: function () {
            if (this.negociocrm && this.negociocrm.pessoa.length > 0)
              return this.negociocrm.pessoa[0]
            else 
              return null
        },

        paramsAgenda: function () {
            return { negocio: this.negociocrm, organizacao: this.organizacao, pessoa: this.pessoa }        
        },

        noDateTotal: function () { 
            return this.$store.getters.getNegocioNoDateTimelineList.total
        },

        noDateList: function () { 
            if (this.$store.getters.getNegocioNoDateTimelineList.lista)
                return this.$store.getters.getNegocioNoDateTimelineList.lista
            else
                return []
        },

    },

    watch: {
        startDate: function (value) {
            this.loadData()
        },

        funil: function (value) {
            this.loadData()
        },

        filtro: function (value) {
            this.loadData()
        },

        usuario: function (value) {
            this.loadData()
        }

    },

    methods: {
        closeAgenda (agenda) {
            this.showFormAgenda = false
            if (agenda) {
                if (!this.negocio_detalhePopover.count_agenda) 
                   this.negocio_detalhePopover.count_agenda = 1
                else
                   this.negocio_detalhePopover.count_agenda = this.negocio_detalhePopover.count_agenda + 1
            }
        },

        handleAdicionarAgenda (negocio) {
            //abre a tela de edicao
            this.negociocrm = negocio
            this.crud = SysVars.crudI 
            this.codagenda = null
            this.showFormAgenda = true;
        },

        handleEditAgenda (negocio, codagenda) {
            //abre a tela de edicao
            this.negociocrm = negocio
            this.crud = SysVars.crudU //operacao de edicao
            this.codagenda = codagenda
            this.showFormAgenda = true; //exibe o form de agenda
        },

        handleEditNegocio (codnegocio) {
            //ABRIR FORM PARA DIGITACAO
            this.$emit('edit', codnegocio)
        },

        async loadData () {
            let query = ''
            if (this.usuario && this.usuario.codusuario) {
              query = query + 'codusuario=' + this.usuario.codusuario
            }

            if (this.equipe) {
              if (query)
                query = query + '&'
              query = query + 'codequipe=' + this.equipe.codequipe
            }

            //carrega a lista de negocios sem data
            await this.$store.dispatch('loadPainelNoDateTimelineListCrm', { codfunil: this.funil.codfunil, query: query })
console.log(this.$store.getters.getNegocioNoDateTimelineList)
            if (this.filtro) {
              if (query)
                query = query + '&'
              query = query + 'codfiltro=' + this.filtro.codfiltro
            }

            if (this.startDate) {
              if (query)
                query = query + '&'
              query = query + 'data=' + apiDateORDS(this.startDate)
            }

            await this.$store.dispatch('loadPainelCrm', { codfunil: this.funil.codfunil, tipo: 'timeline', query: query })

            this.painel = []
            let obj = {}
            let totais = []
            let negocios = []

            this.painel = this.negocioList

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        gravaEtapa () {
            if (!this.negocioDragging)
              return
            let data = {
                    codnegocio: this.negocioDragging.codnegocio, 
                    codetapa: this.codetapa 
                }
            this.apiNegocio(data, data.codnegocio).then
            this.negocioDragging = null
        },

        // DRAG EVENTS
        onChange(evt) {

        },

        onMove({ relatedContext, draggedContext }) {
            this.negocioDragging = draggedContext.element

            const relatedElement = relatedContext.element;
            const draggedElement = draggedContext.element;
            return (
                (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
            );
        },

        onEnd(obj) {
            this.isDragging = false
            this.mesTarget = obj.to.attributes[0].value

            //deve pegar o mesTarget e abrir campo para confirmar a data prevista de fechamento do negocio arrastado
            // this.gravaEtapa()
        }

    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },
    },

    created () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
        this.selectedFunil = this.funil
        this.etapasFunil = this.selectedFunil.etapas
        this.loadData()
    }
  
}
</script>

<style>


</style>






// WEBPACK FOOTER //
// src/forms-crm/crm-painel-timeline.vue